<template>
  <main id="mainContent" class="main-content bg-gray">
    <div class="page-container ptb-10">
      <div class="container" style="background-color: #fff;">
        <div class="section deals-header-area ptb-30">
          <ul style="margin-bottom: 25px;">
            <table width="930" border="0" cellpadding="0" cellspacing="0" style="border:1px solid #999999;margin:0 auto;margin-top:10px;">
              <tbody>
                <tr>
                  <td>
                    <table width="860" border="0" cellpadding="0" cellspacing="0" class="bd1" style="width:860px;margin:0 auto;margin-top:12px;">
                      <tbody>
                        <tr>
                          <td width="70"><b>发布机构：</b></td>
                          <td width="360">{{reportData.publish_agency}}</td>
                          <td width="100"><b>行业：</b></td>
                          <td width="360">{{reportData.industry_name}}</td>
                        </tr>
                        <tr>
                          <td width="70"><b>发布日期：</b></td>
                          <td width="360">{{reportData.publish_date}}</td>
                          <td width="100"><b>备注：</b></td>
                          <!-- <td width="100"><b>主 &nbsp;题 &nbsp;分 &nbsp;类：</b></td> -->
                          <td width="360">{{reportData.remark}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </ul>
          <ul style="text-align: center;margin-top: 10px;margin-bottom: 10px;">
            <h2>{{this.reportData.title}}</h2>
          </ul>
        </div>
        <div class="section deals-header-area ptb-30">
          <p v-if="reportData.content">{{ reportData.content }}</p>
          <div v-else class="row row-tb-20">
            <iframe :src="showFileUrl('doc',reportData.content_file)" frameborder="0" width="100%" height="800px;" v-if="showView('doc',reportData.content_file)"></iframe>
            <embed :src="showFileUrl('pdf',reportData.content_file)" style="width: 100%; height: 800px;" v-if="showView('pdf',reportData.content_file)">
            <!--                        <VueDocPreview value="this.report_url" type="office"></VueDocPreview>-->
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import VueDocPreview from 'vue-doc-preview';
import util from '../../common/js/util';
import { getCase } from '../../api/api';
export default {
  data() {
    return {
      collapse: false,
      show_view_doc: false,
      show_view_pdf: false,
      doc_view: 'https://view.officeapps.live.com/op/view.aspx?src=',
      report_url: '',
      reportData: {},
      title: '',
      title_en: '',
      agency_name: '',
      publish_date: '',
      industry_name: '',
      report: [
        '汽车行业碳中和两会提案解读与速览.pdf',
        '20220329碳边境调节机制.pdf',
        '2019氢燃料电池汽车产业报告.pdf'
      ],
      titles: [
        '汽车行业碳中和两会提案解读与速览',
        '欧盟推进碳边境调节机制进程，钢铁和铝行业将受重大影响',
        '2019氢燃料电池汽车产业报告'
      ],
      titles_en: [
        'Quick View of the Carbon Neutralization Proposals in the Automotive Industry at the Two Sessions',
        'EU CBRM Accelerating, the Steel and Aluminum Industries will be Greatly Affected',
        '2019 Hydrogen Fuel Cell Vehicle Industry Report'
      ],
      publish_dates: [
        '2022年3月10日',
        '2022年3月29日',
        '2019年11月1日'
      ],
      industry: [
        '两会，碳中和，汽车，解读',
        '碳关税，钢铁',
        '储能，汽车制造，交通运输'
      ]
    }
  },
  components: {
    VueDocPreview
  },
  methods: {
    getReportDetail: function () {
      let para = {
        case_id: util.getQueryStringByName('case_id'),
      };
      getCase(para).then((res) => {
        this.reportData = res.data.data;
      });
    },
    showFileUrl: function (type, path) {
      let url = location.protocol + '//' + location.host + encodeURI(path);
      if (type == 'doc') {
        return this.doc_view + url;
      } else {
        return url;
      }
    },
    showView: function (type, path) {
      let suffix = path.substring(path.lastIndexOf('.') + 1).toLowerCase();
      if (type == suffix || type + 'x' == suffix) {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {
  },
  mounted() {
    this.getReportDetail();
  }
}
</script>
